import React from 'react'

const NADLLoanCommitmentReport = ({ handleReset }) => {

  return (
    <div>
      <h4>Loan Commitment Cumulative Totals</h4>
      <p><i>
        If this amount is greater than or equal to $16,000,000.00,
        please contact Colin Deaso at 202-632-8796
        before issuing a commitment.
    </i></p>
      <button onClick={handleReset}>Run a Different Report</button>
      <table className='usa-table-borderless'>
        <thead>
          <tr>
            <th scope='col'>Fiscal Year</th>
            <th scope='col'>Loan Commitment Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              2020
            </td>
            <td>
              $2,507,187.69
            </td>
          </tr>
          <tr>
            <td>
              2019
            </td>
            <td>
              $5,495,162.38
            </td>
          </tr>
          <tr>
            <td>
              2018
            </td>
            <td>
              $4,613,689.70
            </td>
          </tr>
          <tr>
            <td>
              2017
            </td>
            <td>
              $4,838,415.93
            </td>
          </tr>
          <tr>
            <td>
              2016
            </td>
            <td>
              $2,816,172.45
            </td>
          </tr>
          <tr>
            <td>
              2015
            </td>
            <td>
              $3,848,300.00
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export default NADLLoanCommitmentReport